import * as React from 'react'
import { useSelector } from 'react-redux'
import { IOption, IProviderProps } from '@user/components/Filters'
import { selectAllSalesFunnels } from '@user/store/salesFunnel/slice'
import { useGetSalesFunnelListForFilters } from '@user/store/salesFunnel/hooks'

export const SalesFunnelProvider: React.FC<IProviderProps> = ({ render }) => {
  const { isFetching } = useGetSalesFunnelListForFilters()
  const funnels = useSelector(selectAllSalesFunnels)

  const funnelOptions: IOption[] = React.useMemo(
    () => funnels.map(({ id, name }) => ({ label: name, value: id })),
    [funnels],
  )

  return <>{render(funnelOptions, isFetching)}</>
}
SalesFunnelProvider.displayName = 'SalesFunnelProvider'
